import { ICalendarEvent } from "./calendar";
import { IVenue } from "./venue";
import { ITraining, ITrainer } from "./training";
import { IPassItem, ITicketItem } from "./passticket";
import { ISetting } from "./setting";
import { Stream } from "./livestreaming-types";
export type ISportProviderCard = {
  id: number;
  name: string;
  city: string;
  profileimage: string;
  rating: number;
  coverimage: string;
  profileUrl: string;
  urltag: string;
  type: string;
  haslivestreams?: boolean;
};

export interface IService {
  id: number;
  name: string;
  price: number;
}

export type ISportProviderProfileData = {
  id: number;
  providerTitle: string;
  providerType: string;
  name: string;
  city: string;
  avatarUrl: string;
  coverUrl: string;
  rating: number;
  profileUrl: string;
  urltag: string;
  openhours: string[];
  aimgroup: string;
  sports: string[];
  address: string;
  phone: string;
  maplink: string;
  description: string;
  trainers: ITrainer[];
  trainings: ITraining[];
  venues: IVenue[];
  venue_ids: number[];
  calendarslots: ICalendarEvent[] | any;
  services: IService[];
  bookings: string[];
  passes: IPassItem[];
  tickets: ITicketItem[];
  gallery: string[];
  timezone: string;
  currency: string;
  modules: string[];
  rules: string;
  privacy_rules: string;
  prices: string;
  settings: ISetting[];
  public_livestreams?: Stream[];
  type?: ProviderType;
};

export type IProfileSelectorProvider = {
  id: number;
  displayName: string;
  profileImage: string;
  urltag: string;
  type: string;
};

export type ProviderType = "facility" | "organiser" | "coach";

export type ProviderModule =
  | "profile"
  | "calendar"
  | "trainings"
  | "venues"
  | "passes"
  | "tickets"
  | "tournaments"
  | "rankings"
  | "news"
  | "livestreaming"
  | "rules";

export const PROVIDER_MODULES: Record<ProviderType, ProviderModule[]> = {
  facility: [
    "profile",
    "calendar",
    "trainings",
    "venues",
    "passes",
    "tickets",

    "news",
    "livestreaming",
    "rules",
  ],

  organiser: [
    "profile",
    "tournaments",
    "rankings",
    "news",
    "livestreaming",
    // "rules",
  ],
  coach: [
    "profile",
    "calendar",
    "trainings",
    "venues",
    "passes",
    "tickets",
    "news",
    "rules",
    "livestreaming",
  ],
};
